import React, { useState } from 'react';
import { BarChart3, PieChart, CheckCircle2 } from 'lucide-react';


/** * SCREEN 3: PRO RESEARCHER DASHBOARD (LOCKED PREVIEW)
 */
export function ProResearcherDashboard() {
  return (
    <>
      <div className="space-y-10 animate-in fade-in slide-in-from-bottom-8 duration-700">
        <div className="flex items-center justify-between">
          <h2 className="text-5xl font-black uppercase italic tracking-tighter leading-none">Researcher Pro</h2>
          <div className="px-4 py-1.5 bg-accent-500 text-white text-2xs font-black rounded-full uppercase tracking-widest italic">Tier 2 Access Only</div>
        </div>

        <div className="bg-gray-900 rounded-[32px] p-12 text-white relative overflow-hidden shadow-2xl">
          <div className="absolute top-0 right-0 w-full h-full opacity-10 pointer-events-none"></div>
          <div className="absolute top-10 right-10 w-64 h-64 bg-primary-600 rounded-full blur-[80px]"></div>
          <div className="absolute bottom-10 left-10 w-48 h-48 bg-accent-500 rounded-full blur-[60px]"></div>

          <div className="relative z-10 max-w-lg">
            <div className="flex items-center space-x-4 mb-8">
              <div className="w-16 h-16 bg-white/10 backdrop-blur-md rounded-2xl flex items-center justify-center">
                <BarChart3 size={32} className="text-accent-500" />
              </div>
              <div>
                <h3 className="text-3xl font-black uppercase italic tracking-tighter">Vault Analytics</h3>
                <p className="text-2xs font-bold text-gray-500 uppercase tracking-[0.3em]">Institutional Grade Raw Data</p>
              </div>
            </div>

            <p className="text-xl font-bold text-white opacity-80 mb-10 leading-relaxed italic border-l-4 border-accent-500 pl-6">"Gain absolute transparency. Access profession-specific sentiment cross-referencing and high-fidelity regional heatmaps."</p>

            <div className="grid grid-cols-2 gap-4 mb-10">
              <ProFeature label="Regional Variance Maps" />
              <ProFeature label="Professional Cross-Referencing" />
              <ProFeature label="Historical Trend Projection" />
              <ProFeature label="Raw Sentiment Export" />
            </div>

            <button className="px-12 py-5 bg-white text-gray-900 rounded-[22px] font-black uppercase tracking-widest text-sm hover:bg-accent-500 hover:text-white transition-all shadow-xl hover:scale-105">
              Unlock Full Suite — 500 IP
            </button>
          </div>

          <div className="absolute -right-16 top-1/2 -translate-y-1/2 rotate-12 opacity-10">
            <PieChart size={400} />
          </div>
        </div>

        <div className="space-y-6">
          <h4 className="text-xs font-black text-gray-500 uppercase tracking-[0.4em] px-4">Sample Metadata Stream</h4>
          {[1, 2, 3].map(i => (
            <div key={i} className="p-6 bg-white dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700 blur-[3px] pointer-events-none opacity-40 select-none">
              <div className="h-4 w-48 bg-gray-200 dark:bg-gray-700 rounded-full mb-3"></div>
              <div className="h-3 w-32 bg-gray-100 dark:bg-gray-600 rounded-full"></div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

function ProFeature({ label }) {
  return (
    <div className="flex items-center space-x-3 text-white/60">
      <CheckCircle2 size={16} className="text-accent-500" />
      <span className="text-xs font-bold uppercase tracking-tight">{label}</span>
    </div>
  );
}